import { type MutationHookOptions, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { CREATE_PLACE } from 'src/api/places.api';
import type { CreatePlace, CreatePlaceInput, CreatePlaceVariables } from 'types/graphql';

/** `createPlace` on the CreatePlace document; the caller's options (toasts, refetches) pass through untouched. */
export function useCreatePlace(options?: MutationHookOptions<CreatePlace, CreatePlaceVariables>) {
  const [mutate, { loading, error }] = useMutation<CreatePlace, CreatePlaceVariables>(CREATE_PLACE, options);
  const create = useCallback((input: CreatePlaceInput) => mutate({ variables: { input } }), [mutate]);
  return { create, loading, error };
}
